import React from 'react';
import PropTypes from 'prop-types';
import Drawer from 'react-motion-drawer';
import windowSize from 'react-window-size';
import { connect } from 'react-redux';
import { compose, bindActionCreators } from 'redux';
import { firebaseConnect } from 'react-redux-firebase';
import { push } from 'react-router-redux';
import SearchIcon from 'react-icons/lib/fa/search';
import { objToArr } from '../../helpers';
import ActionCreators from '../../redux/actions';
import ProfilePropType from '../../proptypes/profile';
import Styles from './styles';
import TopBar from '../../components/TopBar';
import AppDrawer from '../../components/AppDrawer';
import UserDrawer from '../../components/UserDrawer';
import Input from '../../components/UIKit/Input';

class BasicLayout extends React.Component {
  constructor() {
    super();
    this.state = {
      leftDrawerOpened: false,
      rightDrawerOpened: false,
    };

    this.onProjectClick = this.onProjectClick.bind(this);
    this.onOrganizationClick = this.onOrganizationClick.bind(this);
    this.onLogoutClick = this.onLogoutClick.bind(this);
  }

  onProjectClick(props) {
    this.setState({ leftDrawerOpened: false });
    this.props.push(`/editor/${props.id}`);
  }

  onOrganizationClick(props) {
    this.props.setOrganization(props.id);
  }

  onLogoutClick() {
    this.props.logout();
  }

  render() {
    return (
      <div style={Styles.wrapper}>
        <TopBar
          profile={this.props.profile}
          onUserClick={() => {
            this.setState({ rightDrawerOpened: true });
          }}
          onHamburgerClick={() => {
            this.setState({ leftDrawerOpened: true });
          }}
        >
          {this.props.toolbar}
          {this.props.searchEnabled && (
            <Input
              style={Styles.searchBar}
              accessory={<SearchIcon style={Styles.searchBarIcon} />}
            />
          )}
        </TopBar>
        <Drawer
          {...Styles.leftDrawer}
          open={this.state.leftDrawerOpened}
          onChange={open => this.setState({ leftDrawerOpened: open })}
        >
          <AppDrawer
            projects={objToArr(this.props.projects)}
            onProjectClick={this.onProjectClick}
            match={this.props.match}
          />
        </Drawer>
        <Drawer
          right
          {...Styles.rightDrawer}
          open={this.state.rightDrawerOpened}
          onChange={open => this.setState({ rightDrawerOpened: open })}
        >
          <UserDrawer
            profile={this.props.profile}
            organizations={objToArr(this.props.organizations)}
            onLogoutClick={this.onLogoutClick}
            onOrganizationClick={this.onOrganizationClick}
            currentOrganization={this.props.currentOrganizationId}
          />
        </Drawer>
        {this.props.children}
      </div>
    );
  }
}

BasicLayout.propTypes = {
  children: PropTypes.element,
  profile: ProfilePropType,
  organizations: PropTypes.oneOfType([
    PropTypes.arrayOf(
      PropTypes.shape({
        key: PropTypes.string,
        text: PropTypes.string,
        id: PropTypes.string,
      }),
    ),
    PropTypes.objectOf(PropTypes.any),
  ]),
  projects: PropTypes.oneOfType([
    PropTypes.arrayOf(
      PropTypes.shape({
        key: PropTypes.string,
        text: PropTypes.string,
        id: PropTypes.string,
      }),
    ),
    PropTypes.objectOf(PropTypes.any),
  ]),
  onLogoutClick: PropTypes.func,
  onOrganizationClick: PropTypes.func,
  currentOrganizationId: PropTypes.string,
  onProjectClick: PropTypes.func,
  toolbar: PropTypes.node,
  searchEnabled: PropTypes.bool,
};

BasicLayout.defaultProps = {
  children: null,
  profile: PropTypes.object,
  organizations: [],
  projects: [],
  onLogoutClick: () => {},
  onOrganizationClick: () => {},
  currentOrganizationId: '',
  onProjectClick: () => {},
  toolbar: null,
  searchEnabled: true,
};

const populates = [
  { child: 'createdBy', root: 'users' },
  { child: 'members', root: 'users' },
  { child: 'owners', root: 'users' },
  { child: 'prefab', root: 'prefabs' },
];

function mapStateToProps({ firebase, router, editor }) {
  return {
    auth: firebase.auth,
    projects: firebase.data.projects,
    projectsRequested: firebase.requested.projects,
    location: router.location,
    users: firebase.data.users,
    editor,
    profile: firebase.profile,
    organizations: firebase.data.organizations,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    ...bindActionCreators(ActionCreators, dispatch),
    push: (path) => {
      dispatch(push(path));
    },
  };
}

export default compose(
  connect(({ firebase, organizations }) => ({
    auth: firebase.auth,
    currentOrganizationId: organizations.currentOrganizationId,
  })),
  firebaseConnect(props => [
    {
      path: '/organizations',
      populates,
      queryParams: [`orderByChild=members/${props.auth.uid}`, 'equalTo=true'],
    },
    {
      path: '/projects',
      queryParams: [`orderByChild=organizations/${props.currentOrganizationId}`, 'equalTo=true'],
    },
  ]),
  connect(mapStateToProps, mapDispatchToProps),
)(windowSize(BasicLayout));



// WEBPACK FOOTER //
// ./src/containers/BasicLayout/index.js